// Copyright 2022 andrewzeck
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React, { lazy, Suspense, useEffect, useState } from 'react';
import { DropzoneAreaBase } from 'material-ui-dropzone';

import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import { createStyles, makeStyles, withStyles } from "@material-ui/core/styles";
import RegularButton from '../../components/CustomButtons/Button';
import { uploadProductImage, algoliaIndex } from "../../api";
import _ from "lodash";


import { connect } from "react-redux";

import { SmallUppercase } from "../../text";
import { 
  Box, 
  Grid, 
  Chip, 
  CircularProgress, 
  LinearProgress,
  Paper,
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableBody,
  TableRow
 } from "@material-ui/core";
import GridContainer from "../../components/Grid/GridContainer";
import RootRef from '@material-ui/core/RootRef';


const useStyles = makeStyles(styles);

class ProductImageUploader extends React.Component {
  
  state = {
    files: [],
    results:[],
    uploading: false,
    upload_queue: [],
    upload_progress: 0,
    upload_message: ''
  };
  dropzoneRef = React.createRef();

  componentDidMount(){
    if(this.dropzoneRef){
      const element = this.dropzoneRef.current;
      console.log('mounted', element.children.length);
    }
  }
  onFileAdded(files){
    let filesToAdd = [];
    for(let iter of files){
      let fileName = iter.file.path.split('.')[0]
      let sku_id = fileName.split('_')[0]
      let fileSize = fileName.split('_')[1]
      let found = true, key = '';
      switch(fileSize) {
        case "small":
          key= "image"
          break;
        case "featured":
          key = "featured_image"
          break;
        case "large":
          key = "image_large"
          break;
        default:
          found = false;
          break;
      }
      if(!found){
        console.log('invalid file')
      } else {
        iter.sku_id = sku_id;
        iter.attribute = key;
        filesToAdd.push(iter);
        console.log(JSON.stringify(iter));
      }
    }
    this.setState({files:this.state.files.concat(filesToAdd)})
  }
  fileNameValidator(files){
    console.log('called')
  }
  /*<Dropzone 
          accept={['image/*']}
          onDrop={this.onFileAdded}
          maxFiles={200}
          validator={this.fileNameValidator}
        >
        {({getRootProps, getInputProps}) => (
          <section>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
          </section>
        )}
        </Dropzone>*/
  /**/
  /*
  <DropzoneArea
          acceptedFiles={['image/*']}
          filesLimit={200}
          showPreviews={true}
          showPreviewsInDropzone={false}
          useChipsForPreview
          previewGridProps={{container: { spacing: 1, direction: 'row' }}}
          previewChipProps={{classes: { root: classes.previewChip } }}
          previewText="Selected files"
          onChange={this.onFileAdded}
          validator={this.fileNameValidator}
          onAlert={(message, variant) => console.log(`${variant}: ${message}`)}
        />
  */
  handleDeleteChip(item){
    //console.log('delete', JSON.stringify(item));
    let files = this.state.files;
    console.log(files.length, item.file.path )
    let removed = _.remove(files, (i)=>{
      return item.file.path == i.file.path;
    });

    if(removed){
      this.setState({files:files});
      console.log(files.length, removed.length)
    }
  }
  delayFor(seconds){
    return new Promise((resolve, reject)=>{
      setTimeout(resolve, seconds*1000)
    })
  }
  startFileUploadQueue = async () => {
    console.log('start upload', this.state.files.length)
  
    this.setState({upload_progress:0, uploading:true})
    const { uploading, upload_progress, upload_queue, files, results } = this.state;
    const columns = ["SKU", "Product Name", "Image Size", "Upload Result"]
    let i = 0;
    console.log('start upload', this.state.files.length)
    let updated = new Date();
    for(let file of this.state.files){
      console.log(file.file.path)
      this.setState({upload_message:`Uploading ${file.file.path}...`})
      let res = {};
      try{
        res = await uploadProductImage(file.sku_id, file.attribute, file.data, file.file.path)
        console.log(res.data);
        results.push(res.data);
      } catch(Err){
        if(Err.response && Err.response.data && Err.response.data.message){
          //const responseData = JSON.parse(Err.response.data)
          results.push({result:Err.response.data.message});
        } else{
          console.log(Err.message)
          res.result = Err.message;
          results.push(res);
        }
      }
      i++;
      this.setState({upload_progress:(i/this.state.files.length)*100, results:results});
    }
    this.setState({files:[], upload_progress:0, uploading:false});
    console.log('upload done');
    await algoliaIndex(updated);
  }
  render(){
    const { classes } = this.props;
    const { files, uploading, upload_message, upload_progress, results } = this.state;
    console.log(`uploading:${uploading}, ${upload_message}, ${JSON.stringify(results)}`)
    return (
      <>
        <RootRef rootRef={this.dropzoneRef}>
          <div>
            <DropzoneAreaBase
              acceptedFiles={['image/*']}
              filesLimit={200}
              showPreviews={true}
              showAlerts={['error']}
              showPreviewsInDropzone={false}
              useChipsForPreview
              previewGridProps={{container: { spacing: 1, direction: 'row' }}}
              previewChipProps={{classes: { root: classes.previewChip } }}
              previewText="Selected files"
              onAdd={this.onFileAdded.bind(this)}
              validator={this.fileNameValidator}
            />
          </div>
          <div>
            <GridContainer
              spacing={3}
              direction="row"
              justify="left"
              alignItems="left"
            >
              <Grid item xs={2}>
                { files.map((item)=>(
                    <Chip key={item.file.path} label={item.file.path} size="small" color="primary" className={classes.previewChip} onDelete={()=>{
                      this.handleDeleteChip(item)
                    }} />
                  ))
                }
              </Grid>
            </GridContainer>
          </div>
          <RegularButton
              align={"right"}
              disabled={uploading}
              color={"success"}
              onClick={() => {
                this.startFileUploadQueue()
              }}
            >
            <span>{"Upload"}</span>
          </RegularButton>
            {uploading && (
            <div>
              <LinearProgress variant="determinate" value={upload_progress} />
                <span>{upload_message}</span>
            </div>)
            }
            {results.length && (
              <TableContainer component={Paper}>
                <Table className="results-table" aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="justify">Result</TableCell>
                      <TableCell>SKU</TableCell>
                      <TableCell align="justify">Product Name</TableCell>
                      <TableCell align="justify">Image Attribute</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {results.map((row) => (
                      <TableRow key={row.sku_id}>
                        <TableCell component="th" scope="row">{row.result}</TableCell>
                        <TableCell align="left">{row.sku_id}</TableCell>
                        <TableCell align="left">{row.title} {row.subtitle}</TableCell>
                        <TableCell align="left">{row.attribute}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </RootRef>
      </>
    );
  }
}
export default connect((state) => ({ user: state.app.user }))(
  withStyles(styles)(ProductImageUploader)
);
